import { render } from "./FooterMain.vue?vue&type=template&id=694edb89"
import script from "./FooterMain.vue?vue&type=script&lang=js"
export * from "./FooterMain.vue?vue&type=script&lang=js"
script.render = render

export default script